export enum EStatusTabelaPreco {
    Ativa = 1,
    EmFormacao = 2,
    Inativa = 3
}
